import { TableFooter, TableRow, TableCell } from "@mui/material";
import useGrandTotal from "../../hooks/useGrandTotal";
import { NumberField, RecordContextProvider, TextField } from "react-admin";

const PurchaseNetCardFooterList = () => {
  const { data, isLoading, error } = useGrandTotal("grand-total-gross", {
    approved: 1,
  });

  // if (error) return <Error />;

  return (
    <RecordContextProvider value={data ? data[0] : {}}>
      <TableFooter>
        <TableRow
          sx={{
            "& td": {
              borderTop: "1px solid rgba(224, 224, 224, 1) !important",
            },
            "& .MuiTypography-root": {
              color: (theme) => theme.palette.primary.main,
              fontWeight: "bold",
            },
          }}
        >
          <TableCell></TableCell>
          <TableCell colSpan={4}>
            <RecordContextProvider value={{ name: "TOTAL PEMBELIAN" }}>
              <TextField source="name" />
            </RecordContextProvider>
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="qty" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="value" textAlign="right" />
          </TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableFooter>
    </RecordContextProvider>
  );
};

export default PurchaseNetCardFooterList;
